import React, { Component } from "react";
import { Menu } from "@mui/material";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import ReactPlayer from "react-player";
import { PlayArrow } from "@mui/icons-material";

class MmsImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mmsUrl: "",
      messagename: "",
      mmsType: "",
      anchorEl: null,
      playing: false,
      open: false,
    };
  }

  showMmsImagePreview(anchorEl, rowData) {
    this.setState({
      open: true,
      playing: false,
      mmsUrl: rowData.mmsUrl,
      messagename: rowData.messagename,
      mmsType: rowData.mmsType,
      anchorEl: anchorEl,
    });
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessages");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages");
    } else {
      this.props.navigate("/messages");
    }
  }

  handleClose() {
    this.setState({ open: false });
  }

  handlePlay = () => {
    this.setState({ playing: true });
  };

  handlePause = () => {
    this.setState({ playing: false });
  };

  handlePlayPause = () => {
    this.setState((prev) => ({ playing: !prev.playing }));
  };

  render() {
    return (
      <Menu
        anchorEl={this.state.anchorEl}
        id="dropdown-menu1"
        className="filterDropdownMenu"
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              left: 20,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <div
          style={{
            cursor: "pointer",
            width: "100%",
            height: "100%",
            fontSize: "14px",
          }}
        >
          <div className="p-1 pe-3 ps-3">
            <div className="row mb-2">
              <label
                className="form-label fw-bold"
                htmlFor="collapsible-firstname"
              >
                {this.state.mmsType === "video"
                  ? "This video will be sent with your text."
                  : "This image will be sent with your text."}
              </label>
            </div>

            <div className="col-sm-12 text-center" id="givbeeText">
              {this.state.mmsType === "video" ? (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <ReactPlayer
                    src={this.state.mmsUrl ? this.state.mmsUrl : ""}
                    playing={this.state.playing}
                    width="250px"
                    height="100%"
                    controls={false} // no default controls
                    onClick={this.handlePlayPause}
                    onEnded={() => this.setState({ playing: false })}
                  />

                  {/* Show play button only when not playing */}
                  {!this.state.playing && (
                    <button
                      onClick={this.handlePlayPause}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(0, 0, 0, 0.6)",
                        border: "none",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <PlayArrow style={{ fontSize: 30, color: "white" }} />
                    </button>
                  )}
                </div>
              ) : (
                <img
                  style={{
                    // width: "-webkit-fill-available",
                    // height: "7em",
                    objectFit: "contain",
                    objectPosition: "left",
                    borderRadius: "10px",
                    width: "250px",
                    height: "100%",
                  }}
                  alt=""
                  src={this.state.mmsUrl ? this.state.mmsUrl : ""}
                />
              )}
            </div>
          </div>
        </div>
      </Menu>
    );
  }
}
export default MmsImage;
